import { ApiEnvironment } from '../../models/api-environment';

export class EnterpriseLogsEnvironment extends ApiEnvironment {
  logSearchUrl(accountId: string) {
    return `${this.baseUrl}/api/log/search/${encodeURIComponent(accountId)}`;
  }

  override resolve(environment: unknown) {
    return environment instanceof EnterpriseLogsEnvironment
      ? environment
      : this;
  }
}

export const enterpriseLogsEnvironment = new EnterpriseLogsEnvironment();
